import { NavLink } from 'react-router-dom';
import moment from 'moment';

const TabFinalDesign = ({ tab, finalDesigns, project, id }) => {
  const renderFinalDesignList = () => {
    return finalDesigns.map((finalDesign, index) => (
      <div key={index} className="card card-project">
        <div className="card-body p-5">
          <div className="row item">
            <div className="col-12 col-md-5">
              <div className="d-flex justify-content-around align-items-start">
                <img
                  src={
                    finalDesign.photos[0]?.full_image_url ||
                    '/dist/img/empty/empty-product.png'
                  }
                  className="item-picture"
                  alt="item"
                  loading="lazy"
                />
                <div className="d-flex flex-column ms-4">
                  <dl>
                    <dt>TITLE</dt>
                    <dd>
                      <span className="fs-5 fw-bold">{finalDesign.title}</span>
                    </dd>
                  </dl>
                  <NavLink
                    to={`/project/detail-design/${project?.projectInformatin?.orderNo}/${finalDesign.id}/${id}`}
                    state={{ isFinal: true }}
                    className="badge-yellow"
                  >
                    View
                  </NavLink>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="row row-cols-2 px-5">
                <dl className="col mb-0">
                  <dt>TOTAL ITEM</dt>
                  <dd>1</dd>
                  <dt>LAST UPDATE</dt>
                  <dd>
                    {moment(
                      finalDesign?.lastUpdate.replaceAll(' WIB', ''),
                      'ddd MMM DD HH:mm:ss YYYY',
                      true
                    ).format('ddd DD MMM YYYY HH:mm:ss ') + 'WIB'}
                  </dd>
                </dl>
                <dl className="col mb-0">
                  <dt>CLIENT BUDGET</dt>
                  <dd>Rp {finalDesign.clientBudget}</dd>
                  <dt>STATUS</dt>
                  <dd>
                    <div className="badge-new badge-gray">
                      {finalDesign.status}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderEmptyState = () => (
    <div
      className="d-flex flex-column align-items-center h-100"
      style={{ marginTop: '75px' }}
    >
      <div className="img-wrap" style={{ width: '300px', height: '300px' }}>
        <img src="/dist/img/empty/empty-product.png" alt="item-empty" />
      </div>
      <div
        className="d-flex align-items-center justify-content-center mt-3 fw-bold text-center"
        style={{ maxWidth: '519px' }}
      >
        To submit a final design, you must select from approved design concept
        and click make as final design.
      </div>
    </div>
  );

  return (
    <div
      className={`tab-pane fade ${tab === 'finalDesign' ? 'show active' : ''}`}
      id="fdesign-temp"
      role="tabpanel"
      aria-labelledby="fdesign-tab"
    >
      <div className="fs-5 fw-bold mt-2 mb-4">Final Design</div>

      {finalDesigns && finalDesigns.length > 0
        ? renderFinalDesignList()
        : renderEmptyState()}
    </div>
  );
};

export default TabFinalDesign;
